import axios from "axios";

// Add a response interceptor to parse JSON strings in error responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (typeof error.response?.data === "string") {
      try {
        error.response.data = JSON.parse(error.response.data);
      } catch {
        // If parsing fails, we can choose to ignore the error and keep the original string
      }
    }
    return Promise.reject(error);
  },
);
